import ResponseCode from "../ResponseCode";

const mockUsers = [
  {
    key: "001",
    id: "001",
    nombre: "Juan Doe",
    usuario: "juan.doe",
    grupo: "Administradores",
    departamento: "Sistemas",
    correo: "juan.doe@websalud.com",
    telefono: "809-555-0001",
    estado: "Activo",
    fechaCreacion: "2024-01-15",
  },
  {
    key: "002",
    id: "002",
    nombre: "María Pérez",
    usuario: "maria.perez",
    grupo: "Usuarios",
    departamento: "Servicios",
    correo: "maria.perez@websalud.com",
    telefono: "809-555-0002",
    estado: "Activo",
    fechaCreacion: "2024-01-20",
  },
  {
    key: "003",
    id: "003",
    nombre: "Carlos Rodríguez",
    usuario: "carlos.rodriguez",
    grupo: "Supervisores",
    departamento: "Operaciones",
    correo: "carlos.rodriguez@websalud.com",
    telefono: "809-555-0003",
    estado: "Inactivo",
    fechaCreacion: "2024-02-01",
  },
  {
    key: "004",
    id: "004",
    nombre: "Ana García",
    usuario: "ana.garcia",
    grupo: "Usuarios",
    departamento: "Atención al Cliente",
    correo: "ana.garcia@websalud.com",
    telefono: "809-555-0004",
    estado: "Activo",
    fechaCreacion: "2024-02-10",
  },
];

let nextId = 5;

const consultarUsuarios = async (request) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const {
        usuario = "",
        departamento = "",
        grupo = "",
        pagina = 1,
        registrosPorPagina = 10,
      } = request || {};

      let filteredUsers = [...mockUsers];

      if (usuario) {
        filteredUsers = filteredUsers.filter(
          (user) =>
            user.usuario.toLowerCase().includes(usuario.toLowerCase()) ||
            user.nombre.toLowerCase().includes(usuario.toLowerCase())
        );
      }

      if (departamento) {
        filteredUsers = filteredUsers.filter((user) =>
          user.departamento.toLowerCase().includes(departamento.toLowerCase())
        );
      }

      if (grupo) {
        filteredUsers = filteredUsers.filter((user) =>
          user.grupo.toLowerCase().includes(grupo.toLowerCase())
        );
      }

      const startIndex = (pagina - 1) * registrosPorPagina;
      const endIndex = startIndex + registrosPorPagina;
      const paginatedUsers = filteredUsers.slice(startIndex, endIndex);

      resolve({
        respuesta: {
          codigo: ResponseCode.OK.code,
          mensaje: ResponseCode.OK.message,
        },
        data: {
          usuarios: paginatedUsers,
          paginacion: {
            totalRegistros: filteredUsers.length,
            paginaActual: pagina,
            totalPaginas: Math.ceil(filteredUsers.length / registrosPorPagina),
            registrosPorPagina: registrosPorPagina,
          },
        },
      });
    }, 1000);
  });
};

const crearUsuario = async (userData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const newUser = {
        ...userData,
        key: nextId.toString().padStart(3, "0"),
        id: nextId.toString().padStart(3, "0"),
        fechaCreacion: new Date().toISOString().split("T")[0],
        estado: "Activo",
      };

      mockUsers.push(newUser);
      nextId++;

      resolve({
        respuesta: {
          codigo: ResponseCode.OK.code,
          mensaje: ResponseCode.OK.message,
        },
        data: newUser,
      });
    }, 1000);
  });
};

const actualizarUsuario = async (userData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const index = mockUsers.findIndex((user) => user.id === userData.id);

      if (index !== -1) {
        mockUsers[index] = { ...mockUsers[index], ...userData };
        resolve({
          respuesta: {
            codigo: ResponseCode.OK.code,
            mensaje: ResponseCode.OK.message,
          },
          data: mockUsers[index],
        });
      } else {
        resolve({
          respuesta: {
            codigo: ResponseCode.SERVER_ERROR.code,
            mensaje: "Usuario no encontrado",
          },
          data: null,
        });
      }
    }, 1000);
  });
};

const eliminarUsuario = async (userId) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const index = mockUsers.findIndex((user) => user.id === userId);

      if (index !== -1) {
        const deletedUser = mockUsers.splice(index, 1)[0];
        resolve({
          respuesta: {
            codigo: ResponseCode.OK.code,
            mensaje: ResponseCode.OK.message,
          },
          data: deletedUser,
        });
      } else {
        resolve({
          respuesta: {
            codigo: ResponseCode.SERVER_ERROR.code,
            mensaje: "Usuario no encontrado",
          },
          data: null,
        });
      }
    }, 1000);
  });
};

const obtenerUsuario = async (userId) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const user = mockUsers.find((user) => user.id === userId);

      if (user) {
        resolve({
          respuesta: {
            codigo: ResponseCode.OK.code,
            mensaje: ResponseCode.OK.message,
          },
          data: user,
        });
      } else {
        resolve({
          respuesta: {
            codigo: ResponseCode.SERVER_ERROR.code,
            mensaje: "Usuario no encontrado",
          },
          data: null,
        });
      }
    }, 500);
  });
};

const exportedObject = {
  consultarUsuarios,
  crearUsuario,
  actualizarUsuario,
  eliminarUsuario,
  obtenerUsuario,
};

export default exportedObject;
